import { useState, useEffect } from "react";
import Curation from "../../pages/Curation/Curation";
import LocalStorageService from "../../utils/auth_service/AuthServiceStorage";

const RejectedModule = ({
  modal,
  setModal,
  clientData,
  curationData,
  comment,
  setComment,
}) => {
  const localStorageService = LocalStorageService.getService();
  const [projectDetails, setprojectDetails] = useState({});
  //   const highlightMatch = (text, match) => {
  //     console.log(text, match)
  //     if (!match) return text; // If no match, return the original text
  //     const regex = new RegExp(`(${match})`, 'gi'); // Case-insensitive regex to find match
  //     return text.split(regex).map((part, index) =>
  //         part.toLowerCase() === match.toLowerCase()
  //             ? <span key={index} style={{ backgroundColor: 'yellow' }}>{part}</span>
  //             : part
  //     );
  // };
  useEffect(() => {
    const projectDetails = localStorageService.getProjectDetails();
    setprojectDetails(JSON.parse(projectDetails));
  }, []);

  useEffect(() => {
    if (setComment && clientData.comment) {
      setComment(clientData.comment);
    }
  }, [setComment]);

  const [isAbstractOpen, setIsAbstractOpen] = useState(false);

  const abstractHandler = () => {
    setIsAbstractOpen(!isAbstractOpen);
  };

  const highlightContinuousMatch = (text, match) => {
    if (!match) return text; // If no match, return the original text

    // Split both the text and match_title into arrays of words
    const textWords = text.split(/\s+/);
    const matchWords = match.split(/\s+/);

    let longestMatch = [];

    // Find the longest continuous match between the two arrays of words
    for (let i = 0; i < textWords.length; i++) {
      for (let j = 0; j < matchWords.length; j++) {
        let k = 0;
        while (
          textWords[i + k] === matchWords[j + k] &&
          i + k < textWords.length &&
          j + k < matchWords.length
        ) {
          k++;
        }
        if (k > longestMatch.length) {
          longestMatch = textWords.slice(i, i + k); // Save the longest match
        }
      }
    }

    // Create a regex to highlight the longest match
    const regex = new RegExp(`(${longestMatch.join(" ")})`, "gi");

    // Replace the longest match in the text with highlighted version
    return text.split(regex).map((part, index) =>
      part.toLowerCase() === longestMatch.join(" ").toLowerCase() ? (
        <span key={index} style={{ backgroundColor: "yellow" }}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const highlightMatchExceptA = (text, match) => {
    const wordsText = text.split(/\s+/); // Split the text into words
    const wordsMatch = match.split(/\s+/); // Split the match into words
    const highlightedParts = []; // To store the highlighted parts

    let i = 0;
    let j = 0;

    // Loop through both word arrays
    while (i < wordsText.length && j < wordsMatch.length) {
      if (
        wordsText[i].toLowerCase() === wordsMatch[j].toLowerCase() &&
        wordsText[i].toLowerCase() !== "a"
      ) {
        // If the words match and it's not the word 'a', highlight it
        highlightedParts.push(
          <span key={i} style={{ backgroundColor: "yellow" }}>
            {wordsText[i]}
          </span>
        );
        i++;
        j++;
      } else {
        // Otherwise, just push the text as it is
        highlightedParts.push(wordsText[i]);
        i++;
      }
    }

    // If there are leftover words in the text, add them (even if they don't match)
    while (i < wordsText.length) {
      highlightedParts.push(wordsText[i]);
      i++;
    }

    return highlightedParts;
  };

  const highlightAllContinuousMatches = (text, match) => {
    if (!match) return text; // If no match, return the original text

    // Split both the text and match_title into arrays of words
    const textWords = text.split(/\s+/);
    const matchWords = match.split(/\s+/);

    const matches = [];

    // Find all continuous matches between the two arrays of words
    for (let i = 0; i < textWords.length; i++) {
      for (let j = 0; j < matchWords.length; j++) {
        let k = 0;
        // Check for a match
        while (
          textWords[i + k] === matchWords[j + k] &&
          i + k < textWords.length &&
          j + k < matchWords.length
        ) {
          k++;
        }
        if (k > 1) {
          // Only add matches of 2 or more words (to ensure it’s a real match)
          matches.push(textWords.slice(i, i + k).join(" "));
        }
      }
    }

    // Create a regex to highlight all the matches
    const regex = new RegExp(`(${matches.join("|")})`, "gi");

    // Replace all matches in the text with the highlighted version
    return text.split(regex).map((part, index) =>
      matches.some((match) => part.toLowerCase() === match.toLowerCase()) ? (
        <span key={index} style={{ backgroundColor: "yellow" }}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const highlightAuthorMatches = (text, match) => {
    if (!match) return text; // If no match, return the original text

    text = text?.toString() || "";
    match = match?.toString() || "";

    // text = normalizeDashesAndSpaces(text?.toString() || "");
    // match = normalizeDashesAndSpaces(match?.toString() || "");

    // Split into individual words
    const textWords = text.split(/[\s-–—‐]+/);
    const matchWords = match.split(/[\s-–—‐]+/);
    // const textWords = text.split(/[\s-]+/); // Split by space or hyphen
    // const matchWords = match.split(/[\s-]+/);

    // Find all unique matching words (case insensitive)
    const matches = new Set();
    matchWords.forEach((rawMatchWord) => {
      const matchWord = normalize(rawMatchWord);
      textWords.forEach((rawTextWord) => {
        const textWord = normalize(rawTextWord);

        if (textWord === matchWord) {
          matches.add(textWord); // Already normalized
        }
      });
    });

    if (matches.size === 0) return text; // No matches, return original text
    // Create a regex pattern without word boundaries (`\b`) to match standalone words properly
    // const regex = new RegExp(`(${[...matches].join("|")})`, "gi");

    // Replace matched words with highlighted `<span>` elements
    return text
      .split(/([\s-–—‐]+)/)
      .map((word, index) =>
        matches.has(word.replace(/[;,-]/g, "").toLowerCase().trim()) ? (
          <span key={index} style={{ backgroundColor: "yellow" }}>
            {word}
          </span>
        ) : (
          word
        )
      )
      .reduce((prev, curr) => (prev === null ? [curr] : [...prev, curr]), null);
  };

  function normalize(text) {
    return text
      .toLowerCase()
      .replace(/[;,]/g, "") // Removes semicolons and commas
      .replace(/\s+/g, "") // Converts multiple spaces/tabs/newlines to a single space
      .trim(); // Removes leading and trailing spaces
  }

  // const normalizeDashesAndSpaces = (str) => {
  //   return (
  //     str
  //       // Convert all kinds of dashes/hyphens to ASCII hyphen (-)
  //       .replace(/[\u2010-\u2015\u2212\uFE58\uFE63\uFF0D]/g, "-")
  //       // Convert all kinds of spaces (e.g. NBSP, thin space, etc.) to a normal space
  //       .replace(/[\u00A0\u1680\u180E\u2000-\u200A\u202F\u205F\u3000]/g, " ")
  //   );
  // };

  return (
    <div className="m-3">
      <div>
        <div className="text-muted">Manuscript Name:</div>
        <div className="fw-semibold">
          {highlightAuthorMatches(
            clientData?.submissionTitle,
            curationData?.match_title
          )}
        </div>
      </div>
      <div className="d-flex mt-2">
        <div className="col">
          <div className="text-muted">Manuscript ID:</div>
          <div className="fw-semibold">{clientData.manuscriptId}</div>
        </div>
        <div className="col">
          <div className="text-muted">Date of Rejection:</div>
          <div className="fw-semibold">{clientData.decisionDate}</div>
        </div>
      </div>
      <div className="d-flex mt-2">
        <div className="col">
          <div className="text-muted">Rejecting Journal:</div>
          <div className="fw-semibold">{clientData.submissionJournal}</div>
        </div>
        <div className="col">
          <div className="text-muted">Authors:</div>
          <div className="d-flex">
            <div className="fw-semibold">
              {highlightAuthorMatches(
                clientData.authorFullName,
                curationData?.matched_authorsNames_doi
              )}
            </div>
            <div className="ms-5">
              <select
                id="orchidIdSelect"
                className="form-select form-select-sm"
                onChange={(e) => {
                  var url = e.target.value;
                  if (url && url.startsWith("http")) {
                    window.open(url, "_blank");
                  }
                }}
              >
                <option value="">Select Source</option>
                <option
                  value={`https://orcid.org/orcid-search/search?searchQuery=${encodeURIComponent(
                    clientData.authorFullName
                  )}`}
                >
                  Orchid Id
                </option>
                <option
                  value={`https://openalex.org/works?page=1&filter=title_and_abstract.search%3A${encodeURIComponent(
                    clientData.authorFullName.replace(",", "")
                  )}`}
                >
                  Open Alex
                </option>
                <option
                  value={`https://scholar.google.com/scholar?hl=en&as_sdt=0%2C5&q=${encodeURIComponent(
                    clientData.authorFullName
                  )}`}
                >
                  Google Scholar
                </option>
                <option
                  value={`https://pubmed.ncbi.nlm.nih.gov/?term=${encodeURIComponent(
                    clientData.authorFullName
                  )}`}
                >
                  PubMed
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      {projectDetails.projectId == "5" || projectDetails.projectId == "6" ? (
        <div className="d-flex mt-2">
          <div className="col">
            <div className="text-muted">Co Authors:</div>
            <div className="fw-semibold">{curationData.coAuthors}</div>
          </div>
          <div className="col">
            <div className="text-muted">Corresponding Author:</div>
            <div className="fw-semibold">
              {curationData.correspondingAuthor}
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex mt-2">
          <div className="col">
            <div className="text-muted">Co Authors:</div>
            <div className="fw-semibold">
              {highlightAuthorMatches(
                clientData.coAuthors,
                curationData?.matched_authorsNames_doi
              )}
            </div>
          </div>
          <div className="col">
            <div className="text-muted">Corresponding Author:</div>
            <div className="fw-semibold">
              {highlightAuthorMatches(
                clientData.correspondingAuthor,
                curationData?.matched_authorsNames_doi
              )}
            </div>
          </div>
        </div>
      )}
      <div className="d-flex mt-2">
        <div className="col">
          <div className="text-muted">Submission Type:</div>
          <div className="fw-semibold">{clientData.submissionType}</div>
        </div>
        <div className="col mt-2">
          <div className="text-muted">Rejection Stage:</div>
          <div className="fw-semibold">{clientData.decisionType}</div>
        </div>
      </div>
      {/* <div className="d-flex mt-2">
      

      {comment === undefined  ?( 
        <div className="col mt-2">
        <div className="text-muted">Comment:</div>
        <div className="fw-semibold">{clientData.comment}</div>
      </div>
      ):(

<div className="col mt-2">
        <div className="text-muted">Comment:</div>
        <textarea className="fw-semibold border border-1 rounded border-secondary w-100" rows="2" value={comment}   onChange={(e)=>{setComment(e.target.value)}}></textarea>
      </div>

        
      )}
     </div> */}
      <div className="mt-2">
        <div className="d-inline text-muted" onClick={abstractHandler}>
          Abstract <i className="bi bi-caret-down-fill"> </i>
        </div>
        {isAbstractOpen && (
          <div className="fw-semibold">{clientData.abstractText}</div>
        )}
      </div>
      {/* <a href="#" className="text-primary">
        Show more
      </a> */}
    </div>
  );
};

export default RejectedModule;
